import { RouteProps, useLocation } from 'react-router-dom';

import { useEffect, useState } from 'react';

import { getToken } from '../../helpers';

import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import Sockets from './Sockets';
import * as socket from '../../sockets';
import { useAppDispatch, useAppSelector } from 'hooks';
import { authActions } from 'slices/authSlice';
import { shopSettingActions } from 'slices/shopSettingSlice';

export function PrivateRoutes(props: RouteProps) {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const masterInfoLoading = useAppSelector((state) => state.auth.masterInfoLoading);
  // const [selectedShopId, setSelectedShopId] = useState('');
  useEffect(() => {
    window.ononline = (e) => {
      // console.log('join room when is online');
      const idShopSelect = localStorage.getItem('POS_CUSTOMER_PAYMENT_SELECTED_SHOP');
      socket.clientJoinRoom({
        shop_id: idShopSelect || selectShop.id,
        old_shop_id: null,
      });
    };

    document.addEventListener('visibilitychange', () => {
      // console.log('join room when active tab');
      const idShopSelect = localStorage.getItem('POS_CUSTOMER_PAYMENT_SELECTED_SHOP');
      socket.clientJoinRoom({
        shop_id: idShopSelect || selectShop.id,
        old_shop_id: null,
      });
    });
  }, []);
  const token = getToken();

  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate('/auth');
    }
    // else {
    //   const savedShop = typeof window !== 'undefined' ? localStorage.getItem('selectedShop') : null;
    //   const idShopSelect = localStorage.getItem('ID_SELECTED_SHOP');
    //   if (pathname === '/' && savedShop) {
    //     navigate('/settings');
    //   } else if (pathname === '/rank') {
    //     // setSelectedShopId(idShopSelect);
    //     navigate('/rank');
    //   } else if (pathname === '/settings') {
    //     if (settingTab !== undefined && settingTab !== null) {
    //       navigate('/settings', { state: { tab: settingTab } });
    //     } else {
    //       navigate('/settings');
    //     }
    //   } else {
    //     navigate('/select-shop');
    //   }
    //   // if (idShopSelect) {
    //   // socket.clientJoinRoom({
    //   //   shop_id: idShopSelect || selectShop.id,
    //   //   old_shop_id: null,
    //   // });
    //   // }
    // }
  }, [token, pathname]);
  useEffect(() => {
    if (token) {
      dispatch(authActions.getMasterPermission({ token }));
      dispatch(shopSettingActions.getPermissionByUser({ token }));
    }
  }, [token]);
  return (
    <div className="overflow-hidden">
      <Outlet />
      {/* {selectedShopId && <Sockets />} */}
    </div>
  );
}
